module.exports = __webpack_public_path__ + "img/octal_representation.8cc39963.png";